module.exports = __webpack_public_path__ + "media/images/humidity-red-a8f933d369828d0924f6c6d6d744152e.svg";